import { render, staticRenderFns } from "./BankRemit.vue?vue&type=template&id=49a99c2e&scoped=true"
import script from "./BankRemit.vue?vue&type=script&lang=js"
export * from "./BankRemit.vue?vue&type=script&lang=js"
import style0 from "./BankRemit.vue?vue&type=style&index=0&id=49a99c2e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a99c2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/fe/mewo-website-vue-sea/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49a99c2e')) {
      api.createRecord('49a99c2e', component.options)
    } else {
      api.reload('49a99c2e', component.options)
    }
    module.hot.accept("./BankRemit.vue?vue&type=template&id=49a99c2e&scoped=true", function () {
      api.rerender('49a99c2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BankRemit.vue"
export default component.exports